var map = {
	"./bed.png": 511,
	"./box.png": 809,
	"./cabinet.png": 1792,
	"./casher.png": 8141,
	"./chair.png": 6970,
	"./displayStand.png": 6025,
	"./iceBox.png": 4184,
	"./lamp.png": 7795,
	"./medicalBed.png": 4944,
	"./medicalDisplay.png": 4262,
	"./medicalTool.png": 8349,
	"./pc.png": 5892,
	"./plant.png": 7906,
	"./refrigerator.png": 8145,
	"./shelf.png": 6442,
	"./shopBag.png": 7365,
	"./sofa.png": 7624,
	"./speaker.png": 2923,
	"./table.png": 2146,
	"./tv.png": 1279
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1349;